import React, { useState } from "react"
import { Link } from "gatsby"
import { StaticImage } from 'gatsby-plugin-image'
import { useTranslation } from "gatsby-plugin-react-i18next"

import { Button } from "../button/Button"
import { NavItem } from './nav-item/NavItem'
import { Text } from "../Text/Text"



export const Header = () => {
  const [isActive, setIsActive] = useState(false);

  const navigationToggle = (): void => {
    setIsActive(!isActive)
  }

  const subNavToggle = (target): void => {
    const isActive = target?.classList.contains("active");
    if(isActive) {
      target.classList.remove('active');
    } else {
      const activeNavItem = document.querySelector(".nav-item.active");
      activeNavItem?.classList.remove('active');
      target.classList.add("active");
    }
  }

  const fireAnalyticsCall = (): void => {
    analytics.track("Download Button Clicked")
  }

  const { t } = useTranslation("shared", {
    keyPrefix: "header",
  });

  return (
    <div className="pt-24">
      <header className="fixed bg-white py-6 w-full top-0 z-10">
        <div className="box-border justify-center mx-auto max-w-max-width px-5 lg:flex lg:justify-around">
          <div className="header-main grid grid-cols-[1fr_auto_auto] lg:justify-normal lg:grid-cols-none items-center">
            <div className="mr-2.5">
              <Link to="/">
                <StaticImage
                  alt="Logo"
                  height={28}
                  src="../../images/logos/logo.png"
                  width={147}
                />
              </Link>
            </div>
            <div className="ml-auto lg:hidden">
              <Button 
                classNames="!min-w-0 !md:min-w-0 !py-2.5"
                href="/app/"
                onClick={fireAnalyticsCall}
                text={t("button_text")}
                variant="primary-button-sky" 
              />
            </div>
            <div 
              className={`inline-block lg:hidden text-[30px] ml-6 cursor-pointer ${isActive && "rotate-45 active"}`} 
              onClick={navigationToggle}
            >+</div>
          </div>
          <nav className={`lg:flex lg:items-center ${isActive ? "block active": "hidden"}`}>
            <NavItem 
              navLinks={[
                {
                  name: t("students"),
                  link: "/students/"
                },
                {
                  name: t("adults"),
                  link: "/adults/"
                },
                {
                  name: t("grandparents"),
                  link: "/grandparents/"
                },
              ]}
              setActiveSubNav={subNavToggle}
              title={t("who_its_for")}
            />
            <NavItem 
              navLinks={[
                {
                  name: t("parachute_app"),
                  link: "/parachute-app/"
                },
                {
                  name: t("challenges"),
                  link: "/challenges/"
                },
                {
                  name: t("member_experience"),
                  link: "/how-it-works/"
                },
                {
                  name: t("your_first_visit"),
                  link: "/your-first-visit/"
                },
                {
                  name: t("earning_with_parachute"),
                  link: "/earning-with-parachute/"
                },
              ]}
              setActiveSubNav={subNavToggle}
              title={t("how_it_works")}
            />
            <NavItem 
              navLinks={[
                {
                  name: t("find_a_center"),
                  link: "/plasma-donation/location/"
                },
              ]}
              setActiveSubNav={subNavToggle}
              title={t("locations")}
            />
            <NavItem 
              navLinks={[
                {
                  name: t("our_mission"),
                  link: "/our-mission/"
                },
                {
                  name: t("donating_plasma"),
                  link: "/what-is-donating-plasma/"
                },
              ]}
              setActiveSubNav={subNavToggle}
              title={t("your_impact")}
            />
            <NavItem 
              navLinks={[
                {
                  name: t("blog"),
                  link: "/blog/"
                },
                {
                  name: t("faqs"),
                  link: "https://join-parachute.brainfish.ai/"
                },
              ]}
              setActiveSubNav={subNavToggle}
              title={t("resources")}
            />
            <div className="py-5 lg:ml-5 lg:p-0">
              <div className="[&>*]:py-2.5 [&>*]:min-w-0">
                <Button
                  href="/app/"
                  onClick={fireAnalyticsCall}
                  text={t("button_text")}
                  variant="primary-button-sky"
                />
              </div>
            </div>
            <div className="text-navy py-5 lg:ml-5 lg:p-0 hover:text-sage">
              <Link to="/donor-assessment/">
                <Text variant="small-caption-caps">{t("take_quiz")}</Text>
              </Link>
            </div>
          </nav>
        </div>
      </header>
    </div>
  )
}
